export const EVENT = {
  enquire: 'enquire',
};



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EventListener/constants.js